import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { App, Button } from '@myua/kit';
import * as packActions from '../actions';
import { Trash } from '@myua/icons/dist/bulk16';
import { getData } from '../selectors';
import { getAssetLabLogger } from '../../app/logs';

export const ClearPackButton = () => {
  const dispatch = useDispatch();
  const empty = useSelector(getData).total.read.count === 0;
  const assetLabLogger = useSelector(getAssetLabLogger);
  const { modal } = App.useApp();

  return (
    <Button
      title="Remove all"
      className="al-btn-blue-icon"
      disabled={empty}
      onClick={() => {
        modal.confirm({
          content: 'Are you sure you want to remove all assets from the pack?',
          onOk: (close) => {
            dispatch(packActions.clearPackClicked());
            assetLabLogger({ action: 'Pack', sub_action: 'Clear' });
            close();
          },
          okText: 'Remove all',
          icon: null,
        });
      }}
      icon={<Trash />}
    >
      Clear
    </Button>
  );
};
